import { render } from "./tour-required.vue?vue&type=template&id=90532194&scoped=true"
import script from "./tour-required.vue?vue&type=script&lang=js"
export * from "./tour-required.vue?vue&type=script&lang=js"

import "./tour-required.vue?vue&type=style&index=0&id=90532194&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90532194"]])

export default __exports__